export { default as QuoteCarousel } from './QuoteCarousel';